import { BlockQuote as Bq, QuoteIcon } from './styles'

const BlockQuote = (node, children) => (
  <Bq>
    <QuoteIcon /> {children}
  </Bq>
)

export default BlockQuote
